<div [class.loader-hidden]="!show">
  <div class="loader-overlay">
    <div class="loader-container">
      <!--<label>LOADING...</label>-->
      <div class="loader"></div>
    </div>
  </div>
</div>
